const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#519EF7",
    style: {
      fill: "#519EF7",
      fill: "color(display-p3 0.3176 0.6214 0.9687)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8333 17.8337C22.8333 18.7177 22.4821 19.5656 21.857 20.1907C21.2319 20.8158 20.3841 21.167 19.5 21.167C18.6159 21.167 17.7681 20.8158 17.143 20.1907C16.5179 19.5656 16.1667 18.7177 16.1667 17.8337M12.0858 14.5287H26.9142M12.3333 14.0562C12.117 14.3447 12 14.6955 12 15.0562V26.167C12 26.609 12.1756 27.0329 12.4882 27.3455C12.8007 27.6581 13.2246 27.8337 13.6667 27.8337H25.3333C25.7754 27.8337 26.1993 27.6581 26.5118 27.3455C26.8244 27.0329 27 26.609 27 26.167V15.0562C27 14.6955 26.883 14.3447 26.6667 14.0562L25 11.8337C24.8448 11.6267 24.6434 11.4587 24.412 11.3429C24.1806 11.2272 23.9254 11.167 23.6667 11.167H15.3333C15.0746 11.167 14.8194 11.2272 14.588 11.3429C14.3566 11.4587 14.1552 11.6267 14 11.8337L12.3333 14.0562Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdEdit);
export default __webpack_public_path__ + "static/media/prod_edit.8b7d6570e967995533b89d206b33ffc5.svg";
export { ForwardRef as ReactComponent };